/* eslint-disable import/order */
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
import { getResolutionPlanSSRResource } from '@jira/router-resources__service-desk-ai-context-panel/src/ResolutionPlanSSRResource.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@jira/platform__layouts-issue-preload-layout/src/index.tsx';
import { getIssueViewResources } from '@jira/router-resources__issue-view/src/getIssueViewResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@jira/platform__layouts-route-layout/src/GlobalComponent.tsx';
import { getServiceDeskNavigationResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskReportsTypeRoute } from '@jira/router-routes__servicedesk-reports-routes/src/servicedeskReportsTypeRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { getDraftReplyPillsResource } from '@jira/router-resources__service-desk-draft-reply/src/getDraftReplyPillsResource.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getReportsWithKbResources } from './common/getReportsWithKbResources.tsx';
import ServiceDeskReports, { LazyServicedeskReports } from './ui/async-page/index.tsx';

export const servicedeskReportsTypeRouteEntry: Route = createEntry(
	servicedeskReportsTypeRoute,
	() => ({
		group: 'servicedesk',
		// eslint-disable-next-line no-restricted-syntax
		component: ServiceDeskReports,

		layout: composeLayouts(
			serviceProjectLayout,
			embeddedIssuePreloadLayoutBuilder([
				{
					params: [
						{
							key: 'issueKey',
						},
					],
				},
			]),
		),

		navigation: {
			menuId: MenuIdProjects,
		},

		resources: [
			...getIssueViewResources(),
			...getServiceDeskNavigationResources(),
			...getReportsWithKbResources(),
			getConsolidationStateResource(),
			...getAIContextPanelResources(),
			...getResolutionPlanSSRResource(),
			...getDraftReplyPillsResource(),
		],

		forPaint: [LazyAtlassianNavigation, LazyServicedeskReports],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
